import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function conditionalRequiredValidator(fg: FormGroup, conditionalField: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const conditionalFieldControl = fg.get(conditionalField);
    if (conditionalFieldControl) {
      const condition = conditionalFieldControl.value;
      if (condition) {
        if (control.value == null || control.value === '') {
          const controlName = Object.keys(fg.controls).find(key => fg.controls[key] === control) || 'Field';
          const errorKey = `${controlName}Required`;
          return { [errorKey]: true };
        }
      }
    }
    return null;
  }
}
